import { EventEmitter, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { Observable } from 'rxjs';
import { HelpGetData, HelpShellComponent, HelpStructure } from './help-shell/help-shell.component';

export interface HelpOption<T> {
  title?: string
  structure?: HelpStructure
  data?: T[]
  getData?: HelpGetData<T>
  tableFields?: (string | string[])[],
  // valueField: string | string[],
  nameField?: string // TODO: å¨è¿æ ç¨
  getTableOnSelectTree?: (clickedNode) => Observable<T[]>
  getTree?: () => Observable<T[]> // TODO: åºäºå®
  expandedKeys?: string[]
}

const structureWidthMap = {
  [HelpStructure.table]: 520,
  [HelpStructure.treeTable]: 750,
  [HelpStructure.treeTransfer]: 900,
}

@Injectable({
  providedIn: 'root'
})
export class HelpService {
  private modalRef: NzModalRef

  constructor (
    private modal: NzModalService,
    private translate: TranslateService
  ) { }

  show <T extends object> ({
    title = this.translate.translations[this.translate.currentLang]['pleaseSelect'],
    structure = HelpStructure.table,
    // data = [],
    getData,
    tableFields = ['name'],
    // getTree,
    getTableOnSelectTree,
    expandedKeys
  }: HelpOption<T>) {
    const confirm = new EventEmitter<T | any[]>()
    // const { title = '', structure = 'table', getData, tableFields } = option
    // let helpData: T[] = []
    let helpShellComp: HelpShellComponent<T>

    this.modalRef = this.modal.create({
      nzTitle: title,
      nzContent: HelpShellComponent,
      nzComponentParams: {
        // data,
        getData,
        tableFields,
        structure,
        // getTree,
        getTableOnSelectTree,
        expandedKeys
      },
      nzWidth: structureWidthMap[structure],
      nzClassName: 'body-p-vert-0',
      nzFooter: [{
        label: this.translate.translations[this.translate.currentLang]['confirm'],
        type: 'primary',
        disabled: () => !helpShellComp
          || (!helpShellComp.selectedDataItem && helpShellComp.checkedItems.length === 0),
        onClick: () => {
          confirm.emit(structure === HelpStructure.treeTransfer
            ? helpShellComp.checkedItems
            : helpShellComp.selectedDataItem)
          this.modalRef.destroy()
        }
      },{
        label: this.translate.translations[this.translate.currentLang]['cancel'],
        shape: 'default',
        onClick: () => this.modalRef.destroy()
      }]
    })
    this.modalRef.afterOpen.subscribe(() => {
      helpShellComp = this.modalRef.getContentComponent()
      helpShellComp.selectDataItem.subscribe(dataItem => {
        confirm.emit(dataItem)
        this.modalRef.destroy()
      })
    })
    return confirm
  }
}
